import React from "react";
import LogisticsContainer from "./LogisticsContainer";

interface LogisticsMapProps {}

const LogisticsMap: React.FC<LogisticsMapProps> = () => {
  return <LogisticsContainer />;
};

export default LogisticsMap;
